export default {
  scheduleNotCreated: 'ScheduleNotCreated',
  professionalAlreadyRegisteredForCompany:
    'ProfessionalAlreadyRegisteredForCompany',
  professionalNotFound: 'ProfessionalNotFoundException',
  promotionPastDate: 'Promotion date is in the past',
};
